import { render, staticRenderFns } from "./TextSideMenu.vue?vue&type=template&id=30d83a76&scoped=true&"
import script from "./TextSideMenu.vue?vue&type=script&lang=js&"
export * from "./TextSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./TextSideMenu.vue?vue&type=style&index=0&id=30d83a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d83a76",
  null
  
)

export default component.exports